import * as Sentry from '@sentry/gatsby'

Sentry.init({
  dsn: 'https://32a2464ffd024ecf8350bfb96cfd821f@o191317.ingest.sentry.io/4504102343147520',
  environment: process.env.NODE_ENV,
  debug: process.env.NODE_ENV === 'development',
  enabled: process.env.NODE_ENV !== 'development',
  sampleRate: 0.2,
})
